import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeatherColorLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.5 45.6403C1.5 45.6403 2.72915 15.6392 35.4353 3.58676C63.4538 -3.88072 29.4233 25.1663 29.4233 25.1663L15.4141 26.542L21.9148 31.6875C15.535 36.1721 9.15776 38.3888 2.778 38.3296",
		stroke: "currentColor",
		strokeOpacity: .12,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.3251 45.6403C23.0722 45.6403 23.0722 43.5703 28.8195 43.5703C34.5692 43.5703 34.5692 45.6403 40.3215 45.6403",
		stroke: "#A8AAE3",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFeatherColorLine;
